import { range } from "lodash";
import React from "react";
import PlaceholderComponent from "src/components/global/Placeholder/PlaceholderComponent";

export type TableLoadingFillerProps = {
  rows?: number;
  cols?: number;
};

function TableLoadingFiller({ rows = 2, cols = 1 }: TableLoadingFillerProps) {
  return (
    <>
      {range(0, rows).map((row) => (
        <tr key={row}>
          {range(0, cols).map((col) => (
            <td key={col}>
              <PlaceholderComponent />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default TableLoadingFiller;
